import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;

  .date {
    font-weight: 400;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.gray[600]};
  }

  h2 {
    font-weight: 500;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.gray[600]};
    margin-top: 8px;
  }

  .receivableContainer {
    width: 100%;
    background-color: ${({ theme }) => theme.colors.primary[80]};
    border-left: 3px solid ${({ theme }) => theme.colors.orange.primary};

    border-radius: 8px;

    padding: 12px 16px;
    margin: 20px 0;

    p {
      font-size: 16px;
      color: ${({ theme }) => theme.colors.muted};

      span {
        color: ${({ theme }) => theme.colors.orange.pressing};
        font-weight: 700;
        font-size: 18px;
      }
    }
  }

  .filtersContainer {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 400px));
    gap: 24px;

    @media (max-width: 900px) {
      grid-template-columns: 1fr;
    }
  }

  .chartsContainer {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 32px;

    width: 100%;

    > div {
      flex: 1 1 360px;
      min-width: 320px;
    }
  }
`;
